import i18next from 'i18next';
import I18NextChainedBackend from 'i18next-chained-backend';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import I18nextBrowserLanguageDetectorTWA from './I18nextBrowserLanguageDetectorTWA';
import { i18nextDefaultInitOptions } from './i18nextDefaultInitOptions';

import type { ChainedBackendOptions } from 'i18next-chained-backend';

const i18nextServer = i18next.createInstance();

i18nextServer
  .use(initReactI18next)
  .use(I18nextBrowserLanguageDetectorTWA)
  .use(I18NextChainedBackend)
  .init<ChainedBackendOptions>({
    ...i18nextDefaultInitOptions,
    backend: {
      backendOptions: [
        {
          crossDomain: true,
          loadPath: `${import.meta.env.VITE_SERVER_API_URL}/v1/i18n?lang={{lng}}`,
        },
      ],
      backends: [HttpApi],
    },
    detection: {
      order: ['twa', 'querystring', 'localStorage', 'navigator'],
    },
  });

export { i18nextServer };
